import React, { useState } from "react";
import {
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import Svg, { Path } from "react-native-svg";
import { FontFamily } from "../../styles/appStyles";

function openLink(url) {
  if (url) {
    Linking.openURL(url);
  }
}

export default function MobileFooterAccordion({ title, links = [], index }) {
  const [open, setOpen] = useState(false);
  const [hoveredLink, setHoveredLink] = useState(null);

  return (
    <View style={styles.accordion}>
      <TouchableOpacity
        activeOpacity={0.8}
        onPress={() => setOpen(!open)}
        style={styles.header}
      >
        <Text style={styles.title}>{title}</Text>
        <Svg
          height={16}
          style={[styles.icon, open && styles.iconOpen]}
          viewBox="0 0 20 20"
          width={16}
        >
          <Path
            d="M5 8L10 13L15 8"
            stroke="#9a9384"
            strokeLinecap="round"
            strokeWidth={2}
          />
        </Svg>
      </TouchableOpacity>

      {open ? (
        <View style={styles.links}>
          {links.map((link) => (
            <TouchableOpacity
              activeOpacity={0.8}
              key={link.name}
              onMouseEnter={() => setHoveredLink(link.name)}
              onMouseLeave={() => setHoveredLink(null)}
              onPress={() => openLink(link.url)}
              style={styles.linkItem}
            >
              <Text
                style={[
                  styles.link,
                  hoveredLink === link.name && styles.linkHover,
                ]}
              >
                {link.name}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  accordion: {
    borderBottomColor: "#D9D2C4",
    borderBottomWidth: 1,
    paddingHorizontal: 20,
  },
  header: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 20,
  },
  title: {
    color: "#9a9384",
    fontFamily: FontFamily.interBold,
    fontSize: 12.8,
    fontWeight: "700",
    letterSpacing: 2.56,
    textTransform: "uppercase",
  },
  icon: {
    height: 16,
    width: 16,
  },
  iconOpen: {
    transform: [{ rotate: "180deg" }],
  },
  links: {
    paddingBottom: 20,
  },
  linkItem: {
    marginTop: 12,
  },
  link: {
    color: "#2c2a24",
    fontFamily: FontFamily.interRegular,
    fontSize: 15,
    fontWeight: "400",
    lineHeight: 21,
  },
  linkHover: {
    color: "#0f9e7a",
    textDecorationLine: "underline",
  },
});
